import Navbar from './components/Navbar';
import HeroCarousel from './components/HeroCarousel';
import ProductGrid from './components/ProductGrid';
import SourcingPartners from './components/SourcingPartners';
import SailCollaboration from './components/SailCollaboration';
import SectorsServed from './components/SectorsServed';
import Stats from './components/Stats';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-light">
      <Navbar />

      <main>
        <HeroCarousel />
        <SourcingPartners />
        <SailCollaboration />
        <SectorsServed />
        <Stats />
        <ProductGrid />
        <About />
        <Contact />
      </main>

      <Footer />
    </div>
  );
}

export default App;
